import React, { useState } from "react";
import "../styles/Skills.css";

import { FaFigma, FaDraftingCompass } from "react-icons/fa";
import { FaRegLightbulb } from "react-icons/fa6";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import processImg from "../assets/ui.jpg";

export default function Skills() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const skills = [
    {
      icon: <FaFigma size={60} />,
      title: "UI/UX Tools",
      subtitle: "Figma | Adobe XD | Photoshop | Illustrator",
      description:
        "I craft user-centered interfaces using leading industry tools for wireframing, prototyping, and visual design—balancing creativity and precision to deliver engaging digital experiences.",
      progress: 95,
    },
    {
      icon: <FaDraftingCompass size={60} />,
      title: "Product UI Design",
      subtitle: "Design Systems | Component Libraries | Scalability",
      description:
        "I design intuitive and scalable product interfaces that prioritize accessibility, responsiveness, and a cohesive brand experience across platforms.",
      progress: 90,
    },
    {
      icon: <FaRegLightbulb size={60} />,
      title: "Design Thinking & Strategy",
      subtitle: "Empathize | Ideate | Prototype | Test",
      description:
        "My workflow follows a user-focused design process that emphasizes problem-solving, research, and iteration to create solutions that truly connect with users.",
      progress: 85,
    },
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % skills.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? skills.length - 1 : prev - 1
    );
  };

  return (
    <section id="skills" className="skills">
      <div className="skills-header">
        <h2>My UI/UX Skills</h2>
        <p>
          Blending creativity and strategy to design meaningful user experiences
        </p>
      </div>


      <div className="skills-container">
        {skills.map((skill, index) => (
          <div key={index} className="skill-card">
            <div className="skill-icon">{skill.icon}</div>
            <h3>{skill.title}</h3>
            <h4>{skill.subtitle}</h4>
            <p className="skill-desc">{skill.description}</p>

            <div className="progress-group">
              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{ width: `${skill.progress}%` }}
                />
              </div>
              <span className="progress-text">{skill.progress}%</span>
            </div>
          </div>
        ))}
      </div>


      <div className="skills-slider">
        <button className="slider-btn" onClick={prevSlide}>
          <FaChevronLeft />
        </button>

        <div className="slider-card">
          <div className="skill-icon">
            {skills[currentIndex].icon}
          </div>
          <h3>{skills[currentIndex].title}</h3>
          <h4>{skills[currentIndex].subtitle}</h4>
          <p className="skill-desc">
            {skills[currentIndex].description}
          </p>

          <div className="progress-group">
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${skills[currentIndex].progress}%` }}
              />
            </div>
            <span className="progress-text">
              {skills[currentIndex].progress}%
            </span>
          </div>
        </div>

        <button className="slider-btn" onClick={nextSlide}>
          <FaChevronRight />
        </button>
      </div>


      <div className="workflow-section">
        <div className="workflow-content">
          <h3>My Working Style in UI/UX Design</h3>
          <p>
            I follow a collaborative and research-driven workflow — starting from
            user insights, transforming them into prototypes, and iterating based
            on feedback. Every design decision is backed by usability testing and
            data-driven insights.
          </p>
          <ul>
            <li>🔍 Research & Empathy – Understanding user pain points</li>
            <li>✏️ Ideation & Wireframing – Transforming ideas into low-fidelity mockups</li>
            <li>🎨 Prototyping & Visual Design – Bringing concepts to life with Figma</li>
            <li>🧪 Testing & Iteration – Refining interfaces through feedback loops</li>
          </ul>
        </div>

        <div className="workflow-image">
          <img src={processImg} alt="UI/UX Workflow" />
        </div>
      </div>
    </section>
  );
}